"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactContentError = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var bubbleAlignPoints = [{ align: "bc tc", offset: { x: 0, y: 0 } }];
exports.CompactContentError = function (_a) {
    var className = _a.className, headline = _a.headline, text = _a.text;
    return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, null,
        react_1.default.createElement("div", { className: "info-label-icon " + className }),
        react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignPoints: bubbleAlignPoints },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: headline }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: text }))));
};
//# sourceMappingURL=CompactContentError.js.map